import type { FC } from "react";
import { mergeClasses, rem } from "@huub-web/utils";
import type { ThemeScope } from "@huub-web/ui/contexts/ThemeSlotContext";

import { iconStyle } from "./AbnamroScopeIcon.css";

/**
 * Maps each app scope to its ABN AMRO illustration (the ABN AMRO icon set
 * mirrored from smartfaster-ui). Shared by the page heading and hub cards.
 */
export const ABNAMRO_SCOPE_ICON: Partial<Record<ThemeScope, string>> = {
  orientation: "woningen",
  maximumMortgage: "max-hypotheek",
  financialProfile: "financieel-profiel",
  assessment: "financieel-profiel",
  advice: "financieel-profiel",
  documentsOutgoing: "documenten",
  documentsIncoming: "documenten",
  interestRates: "interest-abnamro",
  advisor: "advisor",
};

type AbnamroScopeIconProps = {
  /**
   * The scope whose illustration should be rendered
   */
  scope: ThemeScope;
  /**
   * Rendered width/height in px (square). Defaults to 80.
   */
  size?: number;
  /**
   * Alt text for the illustration
   */
  alt?: string;
  /**
   * Optional extra class (e.g. to center the icon)
   */
  className?: string;
};

/**
 * Renders the ABN AMRO illustration for a given scope as a plain image.
 */
export const AbnamroScopeIcon: FC<AbnamroScopeIconProps> = ({
  scope,
  size = 80,
  alt = "",
  className,
}) => {
  const icon = ABNAMRO_SCOPE_ICON[scope] ?? "default";

  return (
    <img
      className={mergeClasses(iconStyle, className)}
      src={`/assets/images/illustrations/${icon}.svg`}
      alt={alt}
      width={size}
      height={size}
      style={{ width: rem(size), height: rem(size) }}
      loading="eager"
    />
  );
};
